export default __webpack_public_path__ + "static/media/settings.3809b49d.svg";